import ReactDom from "react-dom";
import SitewideAlert from "./SitewideAlert.jsx";

export default function renderSitewideAlerts(store) {
  document.querySelectorAll(".js-sitewide-alert-mount").forEach((mount) => {
    const alertData = JSON.parse(mount.getAttribute("data-model"));
    const siteAlertState = store.getState();

    const render = (state) =>
      ReactDom.render(
        <SitewideAlert
          {...alertData}
          setSitewideAlert={(sitewideAlert) =>
            store.setState({ siteAlertSet: sitewideAlert })
          }
        />,
        mount,
      );
    store.subscribe(render);
    render(siteAlertState);
  });
}
